import {makeTrackEvent} from './makeTrackEvent';

export type LogsPageAction = 'Label filters applied';
export type LogsPageLocation =
  | 'run-logs'
  | 'sweep-logs'
  | 'group-logs'
  | 'launch-agent-logs';
export type LogsPageEvent = {
  action: LogsPageAction;
  location: LogsPageLocation;
  numLabelsSelected?: number;
  isSearchActive?: boolean;
};

export const trackLogsPage = makeTrackEvent<
  LogsPageEvent,
  {
    action: {
      description: 'the action that took place';
    };
    location: {
      description: 'location/context of the logs';
      exampleValues: ['run-logs', 'sweep-logs'];
    };
    numLabelsSelected: {
      description: 'number of labels selected when filtering logs by labels';
    };
    isSearchActive: {
      description: 'whether a search query is present';
    };
    _description: 'Tracks events on logs pages';
    _location: 'logs';
    _motivation: 'new UI added, track usage';
  }
>('Logs page');
